<template>
  <div class="base-markdown-preview markdown-body" :class="[options.size]" v-html="renderedMarkdown"></div>
</template>

<script>
import MarkdownIt from 'markdown-it';

export default {
  name: 'MarkdownRenderer',
  props: {
    content: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      markdownItInstance: null,
    };
  },
  computed: {
    renderedMarkdown() {
      return this.markdownItInstance.render(this.content);
    },
  },
  created() {
    this.markdownItInstance = MarkdownIt(Object.assign({}, {
      linkify: true,
      html: true,
    }, this.options));
    this.markdownItInstance.linkify.re.src_https = /https:\/\/[a-zA-Z0-9.-]+(?:\/[^\s\u4e00-\u9fa5。]*)?/;
    this.markdownItInstance.linkify.re.src_http = /https:\/\/[a-zA-Z0-9.-]+(?:\/[^\s\u4e00-\u9fa5。]*)?/;

    // 使用 add 方法重新定义 https 链接规则
    this.markdownItInstance.linkify.add('https:', {
      validate: (text, pos) => {
        const tail = text.slice(pos);
        // 匹配到中文字符或空格时停止
        const match = tail.match(/\/\/[a-zA-Z0-9.-]+(?:\/[^\s。，]*)?/);
        if (match) {  
          return match[0].length;
        }
        return 0;
      },
    });
    this.markdownItInstance.linkify.add('http:', {
      validate: (text, pos) => {
        const tail = text.slice(pos);
        // 匹配到中文字符或空格时停止
        const match = tail.match(/\/\/[a-zA-Z0-9.-]+(?:\/[^\s。，]*)?/);
        if (match) {  
          return match[0].length;
        }
        return 0;
      },
    });

    // 保存原有的 link_open 渲染方法
    // eslint-disable-next-line func-names
    const defaultRender = this.markdownItInstance.renderer.rules.link_open || function (tokens, idx, options, env, self) {
      return self.renderToken(tokens, idx, options);
    };

    // 扩展 link_open 渲染方法，给所有链接添加 target="_blank"
    // eslint-disable-next-line func-names
    this.markdownItInstance.renderer.rules.link_open = function (tokens, idx, options, env, self) {
      const aIndex = tokens[idx].attrIndex('target');

      if (aIndex < 0) {
        // 如果没有 target 属性，就加上 target="_blank"
        tokens[idx].attrPush(['target', '_blank']);
      } else {
        // 如果有 target 属性，直接覆盖为 target="_blank"
        tokens[idx].attrs[aIndex][1] = '_blank';
      }

      // 继续处理默认的渲染行为
      return defaultRender(tokens, idx, options, env, self);
    };

  },
};
</script>

<style lang="less">
.markdown-body{
  color: #2F333D;
  &.small{
    font-size: 14px;
  }
  ol{
    list-style-type: decimal;
  }
  ul {
    list-style-type: disc;
  }
  ul ul {
    list-style-type: circle;
  }
  ul ul ul {
    list-style-type: square;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/common-markdown-preview.vue